export const  SafetyStandard={
    "data": [
        "Work Permit system",
        "Working at Height Fall Protection",
        "PPES quidelines",
        "Electrical Safety quidelines",
        "Machenical material handling/lifting",
        "Manual material handling",
        "Driver and Vehicle Safety Voilation",
        "Work Procedure Voilation",
        "Protential Explosive Gas and Vapor",
        "Housekeeping",
        "Access/Egress",
        "Environment Related",
        "Waste Management",
        "Health Related",
        "Fire & Emergency Peparedness",
        "Others"
    ]
}

